<template>
  <div>
    <div class="container d-none d-lg-block relative">
      <div class="absolute position">
        <div class="row downtoup">
          <div class="col-3"  v-for="(item,i) in cardslide" :key="i" >
            <div class="flip-card-CardSlide">
              <div class="flip-card-inner-CardSlide">
                <div class="flip-card-front-CardSlide text-center">
                  <i :class="item.icons " class=" font-60 mt-10"></i>
                  <h5 class="mt-7  bold text-center font-16  px-10"> {{ item.title }} </h5>
                </div>
                <div class="flip-card-back-CardSlide">
                  <h4 class="mt-5 text-center">{{ item.title }}</h4>
                  <p class="mt-4 font-12 text-center px-2">{{ item.text }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container d-block d-lg-none ">
        <div class="row downtoup">
          <div class="col-12 col-md-6 col-lg-6 " v-for="(item,i) in cardslide" :key="i">
                  <div class="light-bg py-5 text-center ">
                    <i :class="item.icons " class="fal fa-alarm-clock font-40"></i>
                    <h5 class="font-18 bold text-center mt-5"> {{ item.title }} </h5>
                  </div>
                <div class="secondary-bg py-5 height rounded">
                    <p class="font-14 text-center px-10 card-text">
                      {{ item.text }}  </p>
                </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: "CardSlide",
  data: () => ({
    cardslide: [],
  }),
  mounted() {
    this.cardslide = this.$getcardslide();
  }
}
</script>

<style scoped>


</style>